import { GetStaticProps } from 'next'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import { NavBar, Footer, AuctionList } from '@foros-fe/core'

export default function Auctions() {
  return (
    <main>
      <div>
        <NavBar />
        <AuctionList />
      </div>
      <Footer />
    </main>
  )
}

export const getStaticProps: GetStaticProps = async ({ locale }) => {
  return {
    props: {
      ssr: true,
      ...(await serverSideTranslations(locale!, ['common', 'auctions', 'enum', 'forest'])),
    },
  }
}
